<template>
  <v-app>
    <AlertSheet></AlertSheet>
    <LoadingDialog></LoadingDialog>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </v-app>
</template>

<script>
import Vue from 'vue';
import AlertSheet from "@/components/Alert/AlertSheet";
import LoadingDialog from "@/components/Loading/LoadingDialog";

export default Vue.extend({
  name: 'App',
  components: {
    AlertSheet,
    LoadingDialog
  },
  data: () => ({
  }),
  methods: {
    setLanguage(language) {
      this.$i18n.locale = language;
      this.$vuetify.lang.current = language;
    },
  },
  mounted() {
    let local = localStorage.local;
    if (!local) {
      localStorage.local = 'en';
      local = 'en';
    }
    this.setLanguage(local);
  }
});
</script>

<style>

html {
  background: #011627;
}

.pointer {
  cursor: pointer;
  user-select:none;
}

.standard-button-height {
    height: 32px !important;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 8px !important;
}

.v-list-item {
  padding: 0 12px!important;
}


.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 38px !important;
}

.v-text-field--filled .v-label, .v-text-field--full-width .v-label {
  top: 10px !important;
  font-size: 14px !important;
}

.v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot {
  min-height: 42px !important;
}

.v-text-field--filled.v-input--dense .v-label, .v-text-field--full-width.v-input--dense .v-label {
  top: 14px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 38px !important;
}

.v-text-field--filled:not(.v-text-field--single-line) input {
  margin-top: 18px !important;
}

.v-toolbar .v-input {
  margin-right: 12px !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 38px;
}

.theme--dark.v-btn-toggle:not(.v-btn-toggle--group) {
  background: none !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 38px !important;
}

.v-btn.v-size--default {
  font-size: 0.825rem !important;
}

input {
  font-size: 0.875rem !important;
}

.v-application .title {
  font-size: 1rem !important;
}

.v-list-group__header .v-list-item__title {
  color: white !important;
}
.v-list-item__title {
  font-size: 0.825rem !important;
}

.v-list-group__header {
  font-weight: 600;
  color: white !important;
}
.mdi-chevron-down::before {
  color: white !important;
}

.v-list-item--active .nav-bar-group-list-title.v-list-item__title {
  color: white !important;
}

.v-list-item--active .v-list-item__icon .mdi-chevron-down::before {
  color: white !important
}

.v-list-item--link {
 border-radius: 4px;
}

.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
  opacity: 0 !important;
}

.v-list .v-list-group__items .v-list-item--active {
   background-color: #2EC4B6;
}

.v-icon.v-icon{
  font-size: 20px
}

.standard-left-table-style {
  padding-left: 0 !important; padding-top: 0 !important
}

.standard-right-table-style {
  padding-right: 0 !important; padding-top: 0 !important
}

.no-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

/*Scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  right:5px;
  position:absolute;
}

::-webkit-scrollbar-thumb {
  background:#505050e7;
  border-radius:10px;
}

.v-data-table__wrapper {
  max-height: 62vh !important;
  overflow-y: auto !important;
}

.auto-height-table .v-data-table__wrapper {
  height: auto !important;
}

.long-height-table .v-data-table__wrapper {
  height: 62vh !important;
}

.full-height-table .v-data-table__wrapper {
  height: 58vh !important;
}

.medium-height-table .v-data-table__wrapper {
  height: 52vh !important;
}

.middling-height-table .v-data-table__wrapper {
  height: 46vh !important;
}

.moderate-height-table .v-data-table__wrapper {
  height: 40vh !important;
}

.small-height-table .v-data-table__wrapper {
  height: 30vh !important;
}

.tiny-height-table .v-data-table__wrapper {
  height: 26vh !important;
}

.tiny-tiny-height-table .v-data-table__wrapper {
  height: 18vh !important;
}

.theme--light.v-label {
  color: rgb(0 0 0 / 74%) !important;
}

.v-input__slot::before {
  border-color: rgb(0 0 0 / 40%) !important;;
}

.v-input__slot {
  background: rgb(223 228 233 / 26%) !important;
}

.show-unset-hs-codes-switch .v-input__slot, .intermediate-material-checkbox .v-input__slot {
  background: none !important;
}

.v-input--is-disabled.v-text-field--filled.v-input--dense .v-label--active {
  color: rgba(0, 0, 0, 0.38) !important;
}

.theme--light.v-text-field.v-input--is-disabled .v-input__slot{
  background: rgb(223 228 233 / 16%) !important;
}

.v-select__selection--comma {
  margin: 7px 4px 7px 4px !important;
}

.v-data-footer__select .v-select .v-input__control {
  border-radius: 4px !important;
}

.v-tabs {
  flex: unset !important;
  width: unset !important;
  min-height: 4vh !important;
  margin-top: 2px !important;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) >
.v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) >
.v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  background-color: #f3f3f3 !important;
}

.v-tab.v-tab {
  color: white !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: 4px !important;
  min-height: 5vh !important;
  margin-bottom: 9px !important;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: rgba(0, 0, 0, 0.54) !important;
}

.v-tabs:not(.v-tabs--vertical) .v-tab {
  background-color: #2EC4B6 !important;
  margin-right: 0.4rem !important;
}

.v-tabs-slider-wrapper {
  height: 0px !important;
}

.v-application .title {
  line-height: 1rem !important;
}

.v-btn.v-size--default{
  font-size: 0.725rem !important;
}

.mdi-checkbox-marked, .mdi-minus-box {
  color: #011627 !important;
}

.v-select.v-text-field input:hover{
  cursor: pointer;
}

.theme--light.v-text-field.v-input--is-disabled .v-input__slot::before {
  border-image: none !important;
}

.fixed-value-exception {
  display: table-cell;
  width: 98px;
  height: 28px;
  border-radius: 4px;
  background: rgba(46, 196, 182, 0.10);
  color: #2EC4B6;
  font-weight: 400;
  letter-spacing: -0.18px;
  text-align: center;
  vertical-align: middle;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.login-button {
  width: 380px;
  height: 48px !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.21px;
}

.login-text-field .v-input__slot{
  border-radius: 4px;
  background: rgba(46, 196, 182, 0.12) !important;
  height: 42px !important; 
}

.login-text-field .v-input__append-inner {
  margin-top: 10px !important;
}

input:-webkit-autofill {
  -webkit-box-shadow: 200px 200px 100px rgba(209, 227, 225, 1) inset !important; 
  box-shadow: 200px 200px 100px rgba(209, 227, 225, 1) inset !important; 
}

.reset-password-label {
  text-align: right
}

.reset-password-label::after {
  content: '';
  width: 0px;
  height: 1px;
  display: block;
  background: #909899;
  transition: 300ms;
}

.reset-password-label:hover::after {
  width: 100%;
}

.reset-password-label:hover {
  cursor: pointer;
}

.login-headline {
  color: #000;
  font-family: 'Asap';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.36px;
  width: 60%;
}

.login-tech-label {
  color: #909899;
  font-family: 'Asap';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.18px;
}

.login-text-field .v-text-field__slot {
  margin-left: 6px;
}

.login-container {
  border-radius: 8px;
  border: 1px solid #D0D7D8;
  background: linear-gradient(130deg, rgba(255, 255, 255, 0.40) 10.45%, rgba(255, 255, 255, 0.12) 91.68%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(3px);
  width: 480px;
  height: 482px;
}

.reset-password-container {
  border-radius: 8px;
  background: linear-gradient(130deg, rgba(255, 255, 255, 0.40) 10.45%, rgba(255, 255, 255, 0.12) 91.68%) !important;
  backdrop-filter: blur(3px);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
}

.login-form-container {
  width: 380px;
  margin-top: 4vh;
}

.login-form-container .v-text-field.v-input--dense .v-label, 
.login-text-field .v-label {
  top: -4px !important
}

.login-form-container .v-input .v-label,
.login-text-field .v-label {
  line-height: 14px !important;
}

.v-data-footer {
  max-height: 46px !important;
}

.is-loading { 
    background-image: linear-gradient(90deg, #efefef, #F7F8F9, #efefef);
    background-size: 400% 400%;
	-webkit-animation: Gradient 4s ease infinite;
	-moz-animation: Gradient 4s ease infinite;
	animation: Gradient 4s ease infinite;
}

@-webkit-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@-moz-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}
</style>
